import {
  INSIGHT_CARD_DATA_REQUEST,
  INSIGHT_CARD_DATA_SUCCESS,
  IS_LOADING,
  PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_SUCCESS,
  PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_SUCCESS,
  PRIORAUTH_METRIC_DEFINITIONS_DATA_SUCCESS,
  PRIORAUTH_TAX_ID_QUICKFILTER_DATA_SUCCESS,
  CASE_SUBMISSION_CHANNELS_DATA_SUCCESS,
  CASE_SUBMISSION_DETAILS_REQUEST,
  CASE_SUBMISSION_DETAILS_SUCCESS,
  CASE_SUBMISSION_DETAILS_ERROR,
  CASE_SUBMISSION_DETAILS_LOADING,
  PRIORAUTH_TURNAROUND_TIME_REQUEST,
  PRIORAUTH_TURNAROUND_TIME_SUCCESS,
  PRIORAUTH_TURNAROUND_TIME_ERROR,
  PRIORAUTH_TURNAROUND_TIME_LOADING,
  CASE_SUBMISSIONS_OVER_TIME_DATA_SUCCESS,
  CASE_SUBMISSIONS_OVER_TIME_DATA_FAILURE,
  CASE_SUBMISSIONS_OVER_TIME_LOADING,
  SET_PRIORAUTH_FILTERS,
  UPDATE_PRIORAUTH_FILTER,
  RESET_PRIORAUTH_FILTER,
  SET_PRIORAUTH_BASE_PAYLOAD,
  INSIGHT_CARD_LOADING,
  CASE_SUBMISSION_CHANNELS_LOADING,
  PRIORAUTH_POLLING_STARTED,
  PRIORAUTH_POLLING_COMPLETED,
  PRIORAUTH_POLLING_FAILED,
  PRIORAUTH_POLLING_RESET,
  PRIORAUTH_NOT_APPROVED_REASONS_REQUEST,
  PRIORAUTH_NOT_APPROVED_REASONS_SUCCESS,
  PRIORAUTH_NOT_APPROVED_REASONS_FAILURE,
  PRIORAUTH_NOT_APPROVED_REASONS_LOADING,
  PRIORAUTH_CPT_CODES_SUCCESS,
  PRIORAUTH_CPT_CODES_FAILURE,
  PRIORAUTH_CPT_APPROVALS_REQUEST,
  PRIORAUTH_CPT_APPROVALS_SUCCESS,
  PRIORAUTH_CPT_APPROVALS_FAILURE,
  SET_PRIORAUTH_CPT_APPROVALS_LOADING,
  PRIORAUTH_GLOBAL_FILTERS_APPLY,
  PRIORAUTH_GLOBAL_FILTERS_RESET,
  PRIORAUTH_GLOBAL_FILTERS_UPDATE,
  SET_PA_TIN_COUNT,
} from '../../actions/actionTypes';

interface PriorAuthState {
  isLoading: boolean;
  quickFilterTaxIdData: any;
  quickFilterAllProvidersData: any;
  extendedTinsTopFilterData: any,
  metricDefinitionsData: any,
  caseSubmissionDetailsData: any;
  caseSubmissionDetailsLoading: boolean;
  caseSubmissionDetailsError: any;
  turnaroundTimeData: any;
  turnaroundTimeLoading: boolean;
  turnaroundTimeError: any;
  insightCardData: any,
  caseSubmissionChannelsData: any,
  caseSubmissionsOverTimeData: any;
  caseSubmissionsOverTimeLoading: boolean;
  caseSubmissionsOverTimeError: any;
  insightCardLoading?: boolean;
  caseSubmissionChannelsLoading?: boolean;
  pollingCount: number;
  tinCount?: number;
  pollingError: any;
  basePayload: any; // Store base payload from saga for tab changes
  currentFilters: {
    // Common filters
    timeperiod?: any;
    // TIN/NPI flow filters
    tin?: any[];
    allProviders?: any;
    // Geo flow filters
    lob?: any;
    requestProvider?: any;
    region?: any;
    state?: any[];
    market?: any[];
  };
  paNotApproved: {
    data: any[];
    loading: boolean;
    error: string | null;
    totalCount: number;
    periodStart: string | null;
    periodEnd: string | null;
  };
  cptApprovals: {
    data: any[];
    loading: boolean;
    error: string | null;
    totalCount: number;
    periodStart: string | null;
    periodEnd: string | null;
    timeperiod: string | null;
  };
  globalFilters: {
    timePeriod: string;
    lineOfBusiness: string;
    providerSetting: string;
    taxId: any[];
    npi: any;
    specialty: any;
    channel: string;
    serviceSetting: string;
    serviceCategory: string;
  };
}

const initialState: PriorAuthState = {
  isLoading: false,
  quickFilterTaxIdData: [],
  quickFilterAllProvidersData: [],
  extendedTinsTopFilterData: {},
  metricDefinitionsData: [],
  insightCardData: null,
  caseSubmissionChannelsData: null,
  caseSubmissionDetailsData: null,
  caseSubmissionDetailsLoading: true,
  caseSubmissionDetailsError: null,
  turnaroundTimeData: null,
  turnaroundTimeLoading: true,
  turnaroundTimeError: null,
  caseSubmissionsOverTimeData: null,
  caseSubmissionsOverTimeLoading: true,
  caseSubmissionsOverTimeError: null,
  pollingCount: 0,
  tinCount: 0,
  pollingError: null,
  basePayload: {}, // Initialize empty base payload
  currentFilters: {},
  insightCardLoading: true,
  caseSubmissionChannelsLoading: true,
  paNotApproved: {
    data: [],
    loading: true,
    error: null,
    totalCount: 0,
    periodStart: null,
    periodEnd: null
  },
  cptApprovals: {
    data: [],
    loading: true,
    error: null,
    totalCount: 0,
    periodStart: null,
    periodEnd: null,
    timeperiod: null
  },
  globalFilters: {
    timePeriod: 'Last12Months',
    lineOfBusiness: 'All',
    providerSetting: 'RF',
    taxId: [],
    npi: null,
    specialty: null,
    channel: 'All',
    serviceSetting: 'All',
    serviceCategory: 'All',
  }
};

const PriorAuthReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PriorAuthState => {
  switch (action.type) {

    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    case PRIORAUTH_TAX_ID_QUICKFILTER_DATA_SUCCESS:
      return {
        ...state,
        quickFilterTaxIdData: action.payload,
      };
    case PRIORAUTH_ALL_PROVIDERS_QUICKFILTER_DATA_SUCCESS:
      return {
        ...state,
        quickFilterAllProvidersData: action.payload,
      };
    case PRIORAUTH_EXTENDED_TINS_TOP_FILTER_DATA_SUCCESS:
      return {
        ...state,
        extendedTinsTopFilterData: action.payload,
      };
    case PRIORAUTH_METRIC_DEFINITIONS_DATA_SUCCESS:
      return {
        ...state,
        metricDefinitionsData: action.payload,
      };

    case CASE_SUBMISSION_DETAILS_REQUEST:
      return {
        ...state,
        caseSubmissionDetailsLoading: true,
        caseSubmissionDetailsError: null,
      };

    case CASE_SUBMISSION_DETAILS_SUCCESS:
      return {
        ...state,
        caseSubmissionDetailsData: action.payload,
        caseSubmissionDetailsLoading: false,
        caseSubmissionDetailsError: null,
        tinCount: action.payload?.TinCount || 0 // ✅ Update tinCount from action payload
      };

    case CASE_SUBMISSION_DETAILS_ERROR:
      return {
        ...state,
        caseSubmissionDetailsLoading: false,
        caseSubmissionDetailsError: action.payload,
      };

    case CASE_SUBMISSION_DETAILS_LOADING:
      return {
        ...state,
        caseSubmissionDetailsLoading: action.payload,
      };

    case PRIORAUTH_TURNAROUND_TIME_REQUEST:
      return {
        ...state,
        turnaroundTimeLoading: true,
        turnaroundTimeError: null,
      };

    case PRIORAUTH_TURNAROUND_TIME_SUCCESS:
      return {
        ...state,
        turnaroundTimeData: action.payload,
        turnaroundTimeLoading: false,
        turnaroundTimeError: null,
      };

    case PRIORAUTH_TURNAROUND_TIME_ERROR:
      return {
        ...state,
        turnaroundTimeLoading: false,
        turnaroundTimeError: action.payload,
      };

    case PRIORAUTH_TURNAROUND_TIME_LOADING:
      return {
        ...state,
        turnaroundTimeLoading: action.payload,
      };

    case INSIGHT_CARD_DATA_SUCCESS:
      return {
        ...state,
        insightCardData: action.payload,
      };
    case CASE_SUBMISSION_CHANNELS_DATA_SUCCESS:
      return {
        ...state,
        caseSubmissionChannelsData: action.payload,
      };
    case CASE_SUBMISSIONS_OVER_TIME_DATA_SUCCESS:
      return {
        ...state,
        caseSubmissionsOverTimeData: action.payload,
        caseSubmissionsOverTimeLoading: false,
        caseSubmissionsOverTimeError: null,
      };
    case CASE_SUBMISSIONS_OVER_TIME_DATA_FAILURE:
      return {
        ...state,
        caseSubmissionsOverTimeLoading: false,
        caseSubmissionsOverTimeError: action.payload,
      };
    case CASE_SUBMISSIONS_OVER_TIME_LOADING:
      return {
        ...state,
        caseSubmissionsOverTimeLoading: action.payload,
      };

    // Filter Management Cases
    case SET_PRIORAUTH_FILTERS:
      return {
        ...state,
        currentFilters: action.payload,
      };

    case UPDATE_PRIORAUTH_FILTER:
      return {
        ...state,
        currentFilters: {
          ...state.currentFilters,
          [action.payload.filterId]: action.payload.value,
        },
      };

    case RESET_PRIORAUTH_FILTER:
      const filterId = action.payload as string;
      const updatedFilters = { ...state.currentFilters };
      delete updatedFilters[filterId];
      return {
        ...state,
        currentFilters: updatedFilters,
      };

    case SET_PRIORAUTH_BASE_PAYLOAD:
      return {
        ...state,
        basePayload: action.payload,
      };

    case INSIGHT_CARD_LOADING:
      return {
        ...state,
        insightCardLoading: action.payload,
      };
    case CASE_SUBMISSION_CHANNELS_LOADING:
      return {
        ...state,
        caseSubmissionChannelsLoading: action.payload,
      };

    // Polling Status Cases - Increment/Decrement counter
    case PRIORAUTH_POLLING_STARTED:
return {
        ...state,
        pollingCount: state.pollingCount + 1,
        pollingError: null,
      };

    case PRIORAUTH_POLLING_COMPLETED:
      return {
        ...state,
        pollingCount: Math.max(0, state.pollingCount - 1), // Prevent negative counts
        pollingError: null,
      };

    case PRIORAUTH_POLLING_FAILED:
      return {
        ...state,
        pollingCount: Math.max(0, state.pollingCount - 1), // Decrement on error too
        pollingError: action.payload,
      };

    case PRIORAUTH_POLLING_RESET:
      return {
        ...state,
        pollingCount: 0,
        pollingError: null,
      };

    // PA Not Approved Reasons Cases
    case PRIORAUTH_NOT_APPROVED_REASONS_LOADING:
      return {
        ...state,
        paNotApproved: {
          ...state.paNotApproved,
          loading: action.payload
        }
      };

    case PRIORAUTH_NOT_APPROVED_REASONS_REQUEST:
      return {
        ...state,
        paNotApproved: {
          ...state.paNotApproved,
          loading: true,
          error: null
        }
      };

    case PRIORAUTH_NOT_APPROVED_REASONS_SUCCESS:
      return {
        ...state,
        paNotApproved: {
          ...state.paNotApproved,
          data: action.payload.data,
          totalCount: action.payload.totalCount,
          periodStart: action.payload.periodStart,
          periodEnd: action.payload.periodEnd,
          loading: false,
          error: null
        }
      };

    case PRIORAUTH_NOT_APPROVED_REASONS_FAILURE:
      return {
        ...state,
        paNotApproved: {
          ...state.paNotApproved,
          loading: false,
          error: action.payload,
          data: []
        }
      };

    case PRIORAUTH_CPT_CODES_SUCCESS:
      // Update the top5 field for the specific reason
      return {
        ...state,
        paNotApproved: {
          ...state.paNotApproved,
          data: state.paNotApproved.data.map(item =>
            item.title === action.payload.reasonDesc
              ? { ...item, top5: action.payload.cptCodes }
              : item
          )
        }
      };

    case PRIORAUTH_CPT_CODES_FAILURE:
      // Optionally handle error - for now just log it
      console.error('CPT Codes fetch failed:', action.payload);
      return state;

    // CPT Approvals Cases
    case SET_PRIORAUTH_CPT_APPROVALS_LOADING:
      return {
        ...state,
        cptApprovals: {
          ...state.cptApprovals,
          loading: action.payload
        }
      };

    case PRIORAUTH_CPT_APPROVALS_REQUEST:
      return {
        ...state,
        cptApprovals: {
          ...state.cptApprovals,
          loading: true,
          error: null
        }
      };

    case PRIORAUTH_CPT_APPROVALS_SUCCESS:
      return {
        ...state,
        cptApprovals: {
          ...state.cptApprovals,
          data: action.payload.data || [],
          totalCount: action.payload.totalCount || 0,
          periodStart: action.payload.periodStart || null,
          periodEnd: action.payload.periodEnd || null,
          timeperiod: action.payload.timeperiod || null,
          loading: false,
          error: null
        }
      };

    case PRIORAUTH_CPT_APPROVALS_FAILURE:
      return {
        ...state,
        cptApprovals: {
          ...state.cptApprovals,
          error: action.payload,
          loading: false
        }
      };

    case SET_PA_TIN_COUNT:
      return {
        ...state,
        tinCount: action.payload,
      };

    case PRIORAUTH_GLOBAL_FILTERS_APPLY:
      return {
        ...state,
        globalFilters: {
          ...state.globalFilters,
          ...action.payload,
        },
      };

    case PRIORAUTH_GLOBAL_FILTERS_RESET:
      return {
        ...state,
        globalFilters: initialState.globalFilters,
      };

    case PRIORAUTH_GLOBAL_FILTERS_UPDATE:
      return {
        ...state,
        globalFilters: {
          ...state.globalFilters,
          [action.payload.filterKey]: action.payload.value,
        },
      };

    default:
      return state;
  }
};

export default PriorAuthReducer;